import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import Tag from "ds/components/Tag";

import ModuleVersionInputsCodePreview from "../../components/CodePreview";
import { isComplexObjectType } from "../../utils";
import { ModuleVersionRequiredInputRow } from "../types";

const ModuleVersionInputsTableTypeCell = <T extends ModuleVersionRequiredInputRow>({
  item: input,
  ...cellProps
}: TableSimpleCellProps<T>) => {
  const isComplex = isComplexObjectType(input.type);

  return (
    <TableSimpleCell {...cellProps}>
      {isComplex && <ModuleVersionInputsCodePreview code={input.type} title={`${input.id} type`} />}
      {!isComplex && <Tag tag={input.type} />}
    </TableSimpleCell>
  );
};

export default ModuleVersionInputsTableTypeCell;
